import { render, staticRenderFns } from "./CreateRoleAction.vue?vue&type=template&id=4d3c613f"
import script from "./CreateRoleAction.vue?vue&type=script&lang=js"
export * from "./CreateRoleAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports